export const ROOMS_INDEX = '@@ROOMS_INDEX'


// WEBPACK FOOTER //
// ./src/features/Hotel/actionTypes.js